import React, {Component, useRef} from "react";
import {connect} from "react-redux";
import {Link, Redirect} from "react-router-dom";
import {auth} from "../../actions/index";
import {InputText} from 'primereact/inputtext';
import {Messages} from 'primereact/messages';
import {Button} from 'primereact/button';
import {Panel} from "primereact/panel";
import { Captcha } from 'primereact/captcha';
import {Toast} from "primereact/toast";


class ResetPassword extends Component {

    state = {
        user_username: "",
        user_email: "",
        disable_submit: true
    }

    onSubmit = e => {
        e.preventDefault();
        this.setState({disable_submit: true});
        this.props.resetpassword(this.state.user_username, this.state.user_email);
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        if (this.props !== nextProps) {
            if (nextProps.management.type === 'RESETPASSWORD_SUCCESFULL') {
                const data = nextProps.management.data;
                if (data.result) {
                    this.messages.show({severity: 'success', summary: data.message});
                } else {
                    this.messages.show({severity: 'error', summary: data.message});
                    this.setState({disable_submit: false});
                }
            }
        }
        return true;
    }
    showResponse = () => {
        this.setState({disable_submit: false})
        this.toast.show({severity: 'info', summary: 'Başarılı', detail: 'Test Başarılı'});
    }

    render() {
        return (

            <div>
                 <Toast ref={(el) => this.toast = el}/>
                <form onSubmit={this.onSubmit}>
                    <Panel header="Şifre Sıfırlama Formu" className="p-login-panel">
                        <div className="p-grid p-login">
                            <div className="p-col p-col-12">
                                <div className="p-inputgroup">
                    <span className="p-inputgroup-addon">
                        <i className="pi pi-user"></i>
                    </span>
                                    <span className="p-float-label">
                        <InputText id="username" name="username" maxLength={32} autoFocus
                                   onChange={e => this.setState({user_username: e.target.value})}/>
                        <label htmlFor="username">Kullanıcı Adı</label>
                    </span>
                                </div>
                            </div>
                            <div className="p-col p-col-12">
                                <div className="p-inputgroup">
                    <span className="p-inputgroup-addon">
                        <i className="pi pi-envelope"></i>
                    </span>
                                    <span className="p-float-label">
                        <InputText id="f_email" name="email" feedback={false}
                                   onChange={e => this.setState({user_email: e.target.value})}/>
                        <label htmlFor="f_email">E-Posta Adresi</label>
                    </span>
                                </div>
                            </div>
                            <div className="p-col p-col-12 recaptcha-box">
                                <Captcha siteKey="6Lc_GYQaAAAAAIXzDP-dTq2Befmuq-G7S2lMrSSA" onResponse={this.showResponse}/>
                            </div>
                            <div className="p-col p-col-12">
                                <Button label="Şifremi Sıfırla!"
                                        className="p-button-danger p-button-rounded p-button-seen p-button-wid"
                                        type="submit"
                                        disabled={this.state.disable_submit}/>
                            </div>
                            <div className="p-col p-col-12">
                                <a className="p-button-seen p-forgetpassword"
                                   onClick={() => window.location.hash = '/login'}>
                                    <b>Giriş ekranına git!</b>
                                </a>
                            </div>
                            <div className="p-col p-col-6">
                            </div>
                            <div className="p-col p-col-12">
                            </div>
                        </div>
                    </Panel>
                </form>

            </div>
        )
    }
}

const mapStateToProps = state => {
    let errors = [];
    if (state.auth.errors) {
        errors = Object.keys(state.auth.errors).map(field => {
            return {field, message: state.auth.errors[field]};
        });
    }
    return {
        errors,
        isAuthenticated: state.auth.isAuthenticated,
        isSending: state.auth.isSending,
        management: state.management
    };
}

const mapDispatchToProps = dispatch => {
    return {
        resetpassword: (user_username, user_email) => {
            return dispatch(auth.resetpassword(user_username, user_email))
        },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);



// WEBPACK FOOTER //
// ./src/pages/authentication/ResetPassword.jsx